"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toHexString = void 0;
const toHexString = (val) => '0x' + val.toString(16);
exports.toHexString = toHexString;
